import { makeObservable, observable, action, computed } from "mobx";

import _ from 'lodash';

import moment from 'moment';

import appStore from '../AppStore';
import { ApiMixin } from "./ApiMixin";
import { TimesheetApi } from "../../util/api/TimesheetApi";

import { Alert } from "../Alert";


//Returns the student object, plus some helper functions
class Timesheet {
    id = null;
    dateSubmitted = null;
    weekEndDate = null;
    dateCertified = null;

    payRate = 0;
    totalHours = 0;

    isSigned = false;
    isOriginalOnFile = false;
    isPaid = false;
    isFinal = false;
    isCertified = false;
    isLogged = false;

    isInactive = false;
    inactiveReason = null;
    dateInactivated = null;
    inactivatedBy = null;
    certifiedBy = null;

    accountId = null;
    timestampIds = null;

    constructor(timesheet = {}, shouldParseValues = false) {

        this.parseValues = this.parseValues.bind(this);
        //Cleans the constructor fields of Formik formatting
        if (shouldParseValues) {
            this.parseValues(timesheet);
        }

        //Adds any default values
        //_.defaults(this, timesheet);
        _.assign(this, timesheet);

        if (timesheet.dateSubmitted) {
            this.dateSubmitted = new Date(timesheet.dateSubmitted)
        }
        if (timesheet.weekEndDate) {
            this.weekEndDate = new Date(timesheet.weekEndDate);
        }
        if (timesheet.dateCertified) {
            this.dateCertified = new Date(timesheet.dateCertified);
        }
    }

    //This function is callsed if we need to parse values from a Formik field.
    parseValues(item) {

        if (item.id) {
            this.id = parseInt(item.id);
        }

        this.isFinal = item.isFinal === "true";
        this.isLogged = item.isLogged === "true";

        this.dateSubmitted = item.dateSubmitted ? new Date(item.dateSubmitted).toISOString() : null;
        this.dateCertified = item.dateCertified ? new Date(item.dateCertified).toISOString() : null;

        this.weekEndDate = new Date(item.weekEndDate).toISOString();


        this.accountId = parseInt(item.accountId);

        this.payRate = parseFloat(item.payRate);
        this.totalHours = parseFloat(item.totalHours);
        this.totalPay = parseFloat(item.totalPay);



        this.isPaid = item.isPaid === "true";
        this.isOriginalOnFile = item.isOriginalOnFile === "true";
        this.isSigned = item.isSigned === "true";
        this.isCertified = item.isCertified === "true";

        this.lockOverride = item.lockOverride == "true";
    }

    get weekEndDateObject() {
        return moment(this.weekEndDate);
    }
    get weekStartDateObject() {
        return moment(this.weekEndDate).subtract(1, "weeks");
    }
    get dateSubmittedObject() {
        return moment(this.dateSubmitted);
    }
    get dateCertifiedObject() {
        return moment(this.dateCertified);
    }


    mutate(timesheet = {}) {

        //This takes all matching keys from the timesheet and assigns them to this object

        _.assign(this, _.pick(timesheet, _.keys(this)));


        if (timesheet.dateSubmitted) {
            this.dateSubmitted = new Date(timesheet.dateSubmitted)
        }
        if (timesheet.dateCertified) {
            this.dateSubmitted = new Date(timesheet.dateCertified)
        }

        if (timesheet.weekEndDate) {
            this.weekEndDate = new Date(timesheet.weekEndDate);
        }

        /*
        this.id = (timesheet.id ? timesheet.id : "");
        this.dateSubmitted = (timesheet.dateSubmitted ? new Date(timesheet.dateSubmitted) : null);
        this.weekEndDate = (timesheet.weekEndDate ? new Date(timesheet.weekEndDate) : "");

        this.payRate = (timesheet.payRate ? timesheet.payRate : 0);
        this.totalHours = (timesheet.totalHours ? timesheet.totalHours : 0);
        this.totalPay = (timesheet.totalPay ? timesheet.totalPay : 0);
        this.isSigned = (timesheet.isSigned ? timesheet.isSigned : false);
        this.isOriginalOnFile = (timesheet.isOriginalOnFile ? timesheet.isOriginalOnFile : false);
        this.isPaid = (timesheet.isPaid ? timesheet.isPaid : false);
        this.isFinal = (timesheet.isFinal ? timesheet.isFinal : false);
        this.isCertified = (timesheet.isCertified ? timesheet.isCertified : false);

        this.accountId = (timesheet.accountId ? timesheet.accountId : null);
        this.timestampIds = (timesheet.timestampIds ? timesheet.timestampIds : []);

        //Converted these dates to moment.js objects for convienience
        //Be careful to clone them before changing them; they're mutable for some reason.

        this.dateSubmittedObject = moment(this.dateSubmitted);
        this.weekEndDateObject = moment(this.weekEndDate);
        this.weekStartDateObject = this.weekEndDateObject.clone().subtract(1, "weeks");*/
    }

    get isLate() {
        //If timesheet is not submitted, check its weekEndDate, and check if today is
        //more than 3 weeks or more after. If so, it's late.   
        if (this.dateSubmitted == null) {
            let currentPayPeriod = moment(appStore.validTimeslots[0].endDay);

            let payPeriodDeadline = moment(currentPayPeriod).startOf('date').subtract(2, "weeks");

            if (this.weekEndDateObject.isBefore(payPeriodDeadline, "day")) {
                return true;
            }
            return false;
        }

        //If timesheet is sumbitted, check dateSubmitted against week end date. If 
        //3 weeks or more, it's late.
        else {
            //Deadline is set two weeks after the current week end object. 
            let payPeriodDeadline = moment(this.weekEndDateObject).startOf('date').add(2, "weeks");

            if (payPeriodDeadline.isBefore(this.dateSubmittedObject, "day")) {
                return true;
            }
            return false;
        }
    }


    //Saves/updates object to the api, shows errors or updates state. 
    async save(appStore, isFormData) {

        const api = ApiMixin(TimesheetApi);

        let response = await api.save(this);

        console.log(response);
        //If there are errors, we iterate over them and display them.
        //Then we return false, in case the parent needs to know we failed.

        if (response.errors.length > 0) {
            _.forEach(response.errors, (error) => {
                appStore.addAlert(error);
            });

            return response;
        }

        //If this already exists in the store, get it we'll be updating it both on api and in store.
        //We also need to check if it is the most recent payperiod (think about another way to do this.)
        //let newTimesheetObject;

        // if (this.id) {

        //     let timesheet = new Timesheet(response.data);
        //     timesheet.timestampIds = this.timestampIds;

        //     let newTimesheetObject = appStore.timesheets.getById(this.id);

        //     //Diff any changes between store and response.
        //     newTimesheetObject.mutate(timesheet);

        // }
        //If not, we're going to save it to the API, and to push it to the store
        // else {

        //     newTimesheetObject = new Timesheet(response.data);

        //     appStore.addItem({ type: "timesheet", data: newTimesheetObject });
        // }


        let newTimesheetObject;

        if (this.id) {
            let timesheet = new Timesheet(response.data);
            timesheet.timestampIds = this.timestampIds;

            newTimesheetObject = appStore.timesheets.getById(this.id);

            if (newTimesheetObject) {
                newTimesheetObject.mutate(timesheet);
            }
        } else {
            newTimesheetObject = new Timesheet(response.data);
            appStore.addItem({ type: "timesheet", data: newTimesheetObject });
        }

        //Success alert
        let successAlert = new Alert("Successfully saved", "Successfully saved timesheet.", "success");
        appStore.addAlert(successAlert);


        //Return the new timesheet object  
        return newTimesheetObject;
    }
}


export default Timesheet;
